import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  title: {
    fontSize: "1.875rem",
    color: "#0F172A",
    textTransform: "capitalize",
    fontWeight: 700,
    marginBottom: "15px",
  },
}));
